import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-question',
  templateUrl: './modal-question.component.html',
  styleUrls: ['./modal-question.component.scss']
})
export class ModalQuestionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
